import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { DataProvider } from './DataContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* BrowserRouter 제거 (App.js에 이미 있기 때문) */}
    <DataProvider>
      <App />
    </DataProvider>
  </React.StrictMode>
);
